import { computed, isRef, Ref } from 'vue';

export function useAddressValidation(
    house: Ref<string> | string,
    appart: Ref<string> | string,
    isFastDelivery: Ref<boolean> | boolean = true
) {
    const houseValue = computed(() =>
        isRef(house) ? (house as Ref<string>).value : (house as string)
    );
    const apartmentValue = computed(() =>
        isRef(appart) ? (appart as Ref<string>).value : (appart as string)
    );
    const isFast = computed(() =>
        typeof isFastDelivery === 'boolean'
            ? isFastDelivery
            : (isFastDelivery as Ref<boolean>).value
    );

    const isHouseValid = computed(() => !!houseValue.value);
    const isApartmentValid = computed(
        () => !!apartmentValue.value || !isFast.value
    );

    const validationMessage = computed(() => {
        if (!houseValue.value) {
            return 'Введите адрес и уточните номер дома для продолжения';
        }
        if (isFast.value && !apartmentValue.value) {
            return 'Введите квартиру для продолжения';
        }
        return '';
    });

    const canProceed = computed(() => {
        if (isFast.value) return !!houseValue.value && !!apartmentValue.value;
        return !!houseValue.value;
    });

    return {
        isHouseValid,
        isApartmentValid,
        canProceed,
        validationMessage,
    };
}
